define([
        'text!./templates/local-date-chooser.html'],
    (template) => {
        function localDate2Date(localDate) {
            return localDate ? new Date(localDate.year, localDate.month, localDate.day) : undefined;
        }

        function date2localDate(date) {
            return date ? {year: date.getFullYear(), month: date.getMonth(), day: date.getDate()} : undefined;
        }

        return [() => ({
            'restrict': 'AE',
            'template': template,
            'scope': {
                'model': '=',
                'maxDate': '=',
                'initialDate': '='
            },
            'controller': ['$scope', ($scope) => {
                $scope.value = localDate2Date($scope.model);
                $scope.initialDateV = localDate2Date($scope.initialDate || $scope.model);
                $scope.maxDateV = localDate2Date($scope.maxDate);

                $scope.$watch('model', (nv) => {
                    $scope.value = localDate2Date(nv);
                    $scope.initialDateV = localDate2Date($scope.initialDate || nv);
                }, true);
                $scope.$watch('value', (nv) => $scope.model = date2localDate(nv), true);
                $scope.$watch('initialDate', (nv) => $scope.initialDateV = localDate2Date(nv || $scope.model), true);
                $scope.$watch('initialDateV', console.log, true);
            }]
        })];
    }
);


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/time/LocalDateChooser.js
 **/